module.exports = __webpack_public_path__ + "img/menu-yy.8242dd6d.png";